import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ErrorHandler, ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { GlobalErrorsHandler } from './global-errors.handler';

@NgModule({
  imports: [CommonModule, RouterModule],
  exports: []
})
export class ErrorsModule {
  constructor(@Optional() @SkipSelf() parentModule: ErrorsModule) {
    if (parentModule) {
      throw new Error('ErrorsModule has already been loaded. You should only import Errors module in the AppModule only.');
    }
  }

  static forRoot(): ModuleWithProviders<ErrorsModule> {
    return {
      ngModule: ErrorsModule,
      providers: [
        GlobalErrorsHandler,
        {
          provide: ErrorHandler,
          useExisting: GlobalErrorsHandler
        }
      ]
    };
  }
}
